export const appConfig = {
    width: 1080,
    height: 1920,
    titleHeight: 439,
    nikeImageFillScale: 0.65,
    productCircleRadius: 452.5,
    lineWidth: 3
}